import React from 'react';
import { Input, Header, Message } from 'semantic-ui-react'

import './forms_inputs_text.css';

const FormsInputsText = ({field, form: {touched, errors}, ...props}) => {
    const hasError = (errors[field.name] && touched[field.name]) ? true : false;
    return (
        <div className="field">
            <>
                <Header as='h5'>{props.label}</Header>
                {(props.secondaryLabel) ? <Header.Subheader>{props.secondaryLabel}</Header.Subheader>: ''}
            </>
            <Input fluid {...field} placeholder={props.placeholder} disabled={(props.disabled) ? props.disabled : false} type={props.type ? props.type : 'text'} className={props.className} {...(props.onChange ? {onChange:props.onChange} : {})}/>
            {
                hasError &&
                (
                    <Message negative>
                        {errors[field.name]}
                    </Message>
                )
            }
        </div>
    );
}

export default FormsInputsText;
